import A from '../analytics';

export const SET_ORDER_STEP = 'SET_ORDER_STEP';
export const SET_LAST_TRANSACTION = 'SET_LAST_TRANSACTION';

export const SET_TRANSACTION_DETAILS = 'SET_TRANSACTION_DETAILS';

export const CLEAR_TRANSACTION_DETAILS = 'CLEAR_TRANSACTION_DETAILS';

export const SET_ORDER_ID = 'SET_ORDER_ID';

export const SET_VEND_DETAILS = 'SET_VEND_DETAILS';

export const SET_CARDS = 'SET_CARDS';

export const SET_CURRENT_SERVICE = 'SET_CURRENT_SERVICE';

export const SET_SERVICE_DISTRIBUTION = 'SET_DISTRIBUTION_SERVICE';

export const setOrderStep = (stage, step) => ({
  type: SET_ORDER_STEP,
  stage,
  step,
});

export const setLastTransaction = data => ({
  type: SET_LAST_TRANSACTION,
  data,
});

export const setTransactionDetails = data => ({
  type: SET_TRANSACTION_DETAILS,
  data,
});

export const clearTransactionDetails = () => ({
  type: CLEAR_TRANSACTION_DETAILS,
});

export const setOrderId = id => {
  A.logAction(SET_ORDER_ID, id);
  return {
    type: SET_ORDER_ID,
    id,
  };
};

export const setVendDetails = data => ({
  type: SET_VEND_DETAILS,
  data,
});

export const setCards = (data = []) => ({
  type: SET_CARDS,
  data,
});

export const setCurrentService = (service) => ({
  type: SET_CURRENT_SERVICE,
  service,
});

export const setServiceDistribution = ({ data, meta }) => ({
  type: SET_SERVICE_DISTRIBUTION,
  data: { data, meta }
});


// WEBPACK FOOTER //
// ./src/actions/orderActions.js